import { useEffect, useState, useRef } from "react";
import { DropDownBox, List } from "devextreme-react";

function LVSelectBoxConList({ textoLabel, textoSelectBox, data, campoCodigo, campoDescripcion, ancho, onValueChanged,
  value, visible = true, readOnly = false, isLoading = false }) {
  const [comboData, setComboData] = useState([]);
  const dropDownRef = useRef(null);

  useEffect(() => {
    if (isLoading) {
      setComboData([{ [campoCodigo]: null, [campoDescripcion]: 'Cargando datos...' }]);
    } else if (!data || data.length === 0) {
      setComboData([{ [campoCodigo]: null, [campoDescripcion]: 'No hay datos disponibles' }]);
    } else {
      // 🔥 Limpiá la data para que solo tenga lo que necesitás
      const cleanData = data.map(item => ({
        [campoCodigo]: item[campoCodigo],
        [campoDescripcion]: item[campoDescripcion],
        Descripcion: item.Descripcion,
      }));
      setComboData(cleanData);
    }
  }, [isLoading, data]);

  const onItemClick = (e) => {
    const selectedItem = e.itemData;

    if (!selectedItem || !selectedItem[campoCodigo]) return;

    if (onValueChanged) {
      onValueChanged({ value: selectedItem[campoCodigo] });
    }

    if (dropDownRef.current) {
      dropDownRef.current.instance.close();
    }
  };

  const contentRender = () => (
    <List
      dataSource={comboData}
      height={300}
      virtualModeEnabled={true} // 🔥 Virtual scrolling activado
      pageLoadMode="scrollBottom"
      searchEnabled={true}
      searchExpr={campoDescripcion}
      itemRender={(item) => (
        <div style={{
          padding: "0px",
          lineHeight: "0.2",
          fontSize: "11px",
          display: "flex",
          height: "8px",
          alignItems: "center"
        }}>
          {item[campoDescripcion]}
        </div>
      )}
      onItemClick={onItemClick}
    />
  );

  const handleValueChanged = (e) => {
    const selectedItem = comboData.find(item => item[campoCodigo] === e.value) || null;
    if (onValueChanged) {
      onValueChanged({
        value: e.value,
        component: {
          option: (opt) => (opt === 'selectedItem' ? selectedItem : undefined)
        }
      });
    }
  };

  return (
    <>
      {/* 🔥 El estilo global para achicar los ítems */}
      <style>{`
        .dx-list-item {
          padding-top: 0px !important;
          padding-bottom: 0px !important;
          line-height: 0 !important;
          min-height: auto !important;
        }
      `}</style>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
        {textoLabel}
        <DropDownBox
          ref={dropDownRef}
          placeholder={textoSelectBox}
          id="custom-templates"
          dataSource={comboData}
          displayExpr={campoDescripcion}
          valueExpr={campoCodigo}
          searchEnabled={true}
          width={ancho}
          onValueChanged={handleValueChanged}
          value={value}
          visible={visible}
          readOnly={readOnly}
          contentRender={contentRender}
        />
        <br />
      </div>
    </>
  );
}

export default LVSelectBoxConList;